import { onMounted } from "vue";

import { useListStore } from "@/stores/lists";

import { useProductModal } from "@/composables/viewFunctions/useProductModal";

import { Information } from "@/types/notification";
import { List, ProductMaster } from "@/types/supplier";
import { AUDIENCE_TYPE } from "@/types/enum/notification";

export function useInformationModal(information: Information) {
    const { createListDialogInformation } = useProductModal()
    const listStore = useListStore()
    let informationSupplierLists: List[];
    const evaluateLists = (supplierIds?: string[]): List[] => {
        const supplierLists: List[] = []

        if (supplierIds) {
            for (const supplierId of supplierIds) {
                const supplierList = listStore.supplierLists(supplierId)
                supplierLists.push(...supplierList)
            }
            return supplierLists
        }

        if (information.audience.type === AUDIENCE_TYPE.ALL) return listStore.lists.data

        if (information.audience.type === AUDIENCE_TYPE.CUSTOMER) {
            for (const supplierId of information.audience.participatingSupplierIds) {
                const supplierList = listStore.supplierLists(supplierId)
                supplierLists.push(...supplierList)
            }
            return supplierLists
        }

        return supplierLists
    }

    const addInformationProductToList = (product: ProductMaster, amount: number, noAutoSelect?: boolean, informationId?: string) => {
        const productLists = evaluateLists(product.availableBy)

        return createListDialogInformation(productLists, amount, informationId || information.id, product.id, noAutoSelect)
    }

    onMounted(() => {
        informationSupplierLists = evaluateLists()
    })

    return {
        addInformationProductToList
    }
}

export function useInformationModalDynamic() {
    const { createListDialogInformation } = useProductModal()
    const listStore = useListStore()
    const evaluateLists = (information: Information): List[] => {
        if (information.audience.type === AUDIENCE_TYPE.ALL) return listStore.lists.data

        const supplierLists: List[] = []

        if (information.audience.type === AUDIENCE_TYPE.CUSTOMER) {
            for (const supplierId of information.audience.participatingSupplierIds) {
                const supplierList = listStore.supplierLists(supplierId)
                supplierLists.push(...supplierList)
            }
            return supplierLists
        }

        return supplierLists
    }

    const addInformationProductToList = (productId: string, amount: number, lists: List[], information: Information) => {
        return createListDialogInformation(lists, amount, information.id, productId)
    }


    return {
        addInformationProductToList,
        evaluateLists
    }
}
